import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const TransactionFilters = ({ filters, searchTerm, onFilterChange, onSearch, onReset }) => {
  const statusOptions = [
    { value: '', label: 'All Status' },
    { value: 'success', label: 'Success' },
    { value: 'pending', label: 'Pending' },
    { value: 'failed', label: 'Failed' }
  ];

  const paymentMethodOptions = [
    { value: '', label: 'All Methods' },
    { value: 'credit_card', label: 'Credit Card' },
    { value: 'debit_card', label: 'Debit Card' },
    { value: 'bank_transfer', label: 'Bank Transfer' },
    { value: 'e_wallet', label: 'E-Wallet' },
    { value: 'qris', label: 'QRIS' }
  ];

  return (
    <div className="bg-card border border-border rounded-xl p-4 shadow-sm">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        {/* Search */}
        <div className="md:col-span-2">
          <div className="relative">
            <Icon name="Search" size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input
              type="text"
              placeholder="Search by transaction ID or customer..."
              value={searchTerm}
              onChange={(e) => onSearch(e?.target?.value)}
              className="pl-10"
            />
          </div>
        </div>

        {/* Status Filter */}
        <div>
          <Select
            value={filters?.status || ''}
            onChange={(e) => onFilterChange({ ...filters, status: e?.target?.value })}
            options={statusOptions}
          />
        </div>

        {/* Payment Method Filter */}
        <div>
          <Select
            value={filters?.paymentMethod || ''}
            onChange={(e) => onFilterChange({ ...filters, paymentMethod: e?.target?.value })}
            options={paymentMethodOptions}
          />
        </div>

        {/* Date Range */}
        <div className="flex gap-2">
          <Input
            type="date"
            value={filters?.dateFrom || ''}
            onChange={(e) => onFilterChange({ ...filters, dateFrom: e?.target?.value })}
            placeholder="From"
          />
        </div>
      </div>

      {/* Reset Button */}
      {(searchTerm || filters?.status || filters?.paymentMethod || filters?.dateFrom) && (
        <div className="mt-4 flex justify-end">
          <Button
            variant="outline"
            size="sm"
            onClick={onReset}
            className="flex items-center gap-2"
          >
            <Icon name="X" size={16} />
            Reset Filters
          </Button>
        </div>
      )}
    </div>
  );
};

export default TransactionFilters;